import { OptionGroupProps } from '@ott/autocomplete';

import { GeoAutocompleteOption, Suggestion } from '../types';
import { SUGGESTION_GROUP_NAMES } from './prepareSuggestions';

export type SuggestionsByCategories = {
  history: GeoAutocompleteOption[];
  popular: GeoAutocompleteOption[];
  nearest: GeoAutocompleteOption[];
  russian: GeoAutocompleteOption[];
  otherCountries: GeoAutocompleteOption[];
};

const checkIfOptionGroup = (option: Suggestion): option is OptionGroupProps => {
  return Boolean(option.isOptionGroup);
};

const getSuggestionsByCategories = (suggestions: Suggestion[]): SuggestionsByCategories => {
  let currentGroupLabel = '';

  return suggestions.reduce<{
    history: GeoAutocompleteOption[];
    popular: GeoAutocompleteOption[];
    nearest: GeoAutocompleteOption[];
    russian: GeoAutocompleteOption[];
    otherCountries: GeoAutocompleteOption[];
  }>(
    (acc, current) => {
      if (checkIfOptionGroup(current)) {
        currentGroupLabel = current.label;
      } else if (currentGroupLabel === SUGGESTION_GROUP_NAMES.HISTORY) {
        acc.history.push(current);
      } else if (currentGroupLabel === SUGGESTION_GROUP_NAMES.POPULAR) {
        acc.popular.push(current);
      } else if (currentGroupLabel === SUGGESTION_GROUP_NAMES.NEAREST) {
        acc.nearest.push(current);
      } else if (currentGroupLabel === SUGGESTION_GROUP_NAMES.RUSSIAN) {
        acc.russian.push(current);
      } else if (currentGroupLabel === SUGGESTION_GROUP_NAMES.OTHER_COUNTRIES) {
        acc.otherCountries.push(current);
      }

      return acc;
    },
    {
      history: [],
      popular: [],
      nearest: [],
      russian: [],
      otherCountries: [],
    }
  );
};

export default getSuggestionsByCategories;
